export const environment = {
  baseUrl: 'https://backendprojects.ccscleaning.com/api/',
  socketUrl: 'https://backendprojects.ccscleaning.com',
  backendSecretKey: 'KUNU-VolkovIndia-7777',
  production: true,
  localStorageSecretKey: 'beautiful129*876 Rashmi',
  adminUrl: '/admin',
  acccountManagerUrl: '/account-manager',
  areaManagerUrl: '/area-manager',
  serviceEngineerUrl: '/service-engineer',
  appUrl: 'https://projects.ccscleaning.com',
  clientId: '5efb07a4-092f-4e20-a3f5-b1df21703cc1',
  allowed_countries: ['UK', 'IE', 'AT', 'BE', 'FR', 'DE', 'NL', 'PL'],
  authority:
    'https://login.microsoftonline.com/4d2f2674-4fb2-4849-87f4-a7f7140172cc',
  guestUrl: '/guest',
  googlePlaceApiKey: 'AIzaSyAUc5KPygalKXNqkFmLtyL0ZurvXTl4mGM',
  ecosystemUrls: {
    coreHub: 'https://core.ccscleaning.com/',
    coreProjects: 'https://projects.ccscleaning.com/',
    coreAcademy: 'https://academy.ccscleaning.com/',
  },
  coreUrl: 'https://core.ccscleaning.com',
  academyUrl: 'https://academy.ccscleaning.com',
  connectUrl: 'https://connect.ccscleaning.com',

};
